<template lang='pug'>
//- 醫生推薦名單區塊
div(:class='$style[`cc-popbox-agree-list`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 已給
        span.font-doctor-theme 推薦
        span.no-wrap 者

    div(:class='$style[`cc-content-list`]')

      perfect-scrollbar(:tag='`ul`' :class='$style[`cc-content-list-ul`]' ref='customScrollBarDom')
        li(v-for='(items, index) in dataContainer' :key='index' :class='$style[`cc-content-list-name`]')
          div(
            :title='`查看${items.firstName}${items.lastName}醫師的檔案`'
            :class='$style[`cc-content-list-left`]'
            @click='handleGoToDoctorProfile(items.id)')

            figure(v-if='items.thumbSrc' :class='$style[`cc-content-list-thumb`]')
              img(:src='avatarSrcLink(items.thumbSrc)' width='100%' height='100%')

            figure(v-else :class='$style[`cc-content-list-thumb`]')
              img(
                v-if='items.gender === `0`'
                :src='`${STATIC_URL}images/common/user/doctor_male.webp`'
                width='100%'
                height='100%')
              img(
                v-else
                :src='`${STATIC_URL}images/common/user/doctor_female.webp`'
                width='100%'
                height='100%')

            div(:class='$style[`cc-content-list-detail`]')
              div(:class='$style[`cc-content-list-detail-top`]')
                span.font-doctor-theme.font-medium {{ `${items.firstName}${items.lastName}` }}

                div(:class='[$style[`cc-content-list-detail-top-verify-icon`], $style[items.verified ? `cc-is-verify` : ``]]')
                  IconConfirm(:size='10' :color='`#fff`')
              div(v-if='items.character' :class='$style[`cc-content-list-detail-bottom`]')
                span {{ `${items.character}` }}

          div(:class='$style[`cc-content-list-right`]')
            div(
              :title='`查看${items.firstName}${items.lastName}醫師的檔案`'
              :class='$style[`cc-content-list-right-profile`]'
              @click='handleGoToDoctorProfile(items.id)')
              IconUser(:size='17' :color='`#b1b1b1`')
              span!= '個人檔案'

        infinite-loading(:class='$style[`cc-content-infinite-load`]' :identifier='infiniteId' @infinite='infiniteHandler')
          IconLoading(slot='spinner' :size='30' :color='`#b1b1b1`')
          div.infinite-scroll-slot(slot='no-more' style='display: none; font-size: 0')
          div.infinite-scroll-slot(slot='no-results' style='display: none; font-size: 0')

</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

import IconLoading from '../../icon/Loading';
import IconConfirm from '../../icon/Confirm';
import IconUser from '../../icon/User';

import {
  getAgreeDoctorList,
} from '../../../js/restapi';

export default {
  components: {
    IconLoading,
    IconConfirm,
    IconUser,
  },

  props: {
    dataType: {
      type: String,
      default: '',
    },
    // 訊息文字
    dataId: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showLoading: false,
      dataSize: 6,
      dataFirstLoadDone: false,
      dataCurrentIndex: 1,
      dataContainer: [],
      infiniteId: +new Date(),
    };
  },

  created() {
    this.showErrorMsg = this.$options.data().showErrorMsg;
    this.loginFailed = this.$options.data().loginFailed;
  },

  mounted() {
    // const refScrollBar = this.$refs.customScrollBarDom;
    // const ps = new CustomScrollbar(refScrollBar);
    this.handleAxiosDataTypeOnLoad(this.popAgreeListStatus.type, this.popAgreeListStatus.id);
  },

  methods: {
    ...mapMutations({
      changePopAgreeListStatus: 'global/POPAGREE_LIST_STATUS',
    }),

    handleClosePopBox() {
      this.changePopAgreeListStatus({
        active: false,
        type: '',
        id: '',
      });
    },

    infiniteHandler($state) {
      if (this.dataFirstLoadDone) {

        if (this.popAgreeListStatus.type === 'article') {
          const passData = {
            article_id: `${this.popAgreeListStatus.id}`,
            resume_id: '',
            scoop_id: '',
            q_id: '',
            card: '',
          };

          this.axiosGetAgreeListDataLazyLoad(passData, $state);
          // setTimeout(() => {
          //   this.axiosGetAgreeListDataLazyLoad(passData, $state);
          // }, 1000);
        } else if (this.popAgreeListStatus.type === 'scoop') {
          const passData = {
            article_id: '',
            resume_id: '',
            scoop_id: `${this.popAgreeListStatus.id}`,
            q_id: '',
            card: '',
          };

          this.axiosGetAgreeListDataLazyLoad(passData, $state);
          // setTimeout(() => {
          //   this.axiosGetAgreeListDataLazyLoad(passData, $state);
          // }, 1000);
        } else if (this.popAgreeListStatus.type === 'resume') {
          const passData = {
            article_id: '',
            resume_id: `${this.popAgreeListStatus.id}`,
            scoop_id: '',
            q_id: '',
            card: '1',
          };

          this.axiosGetAgreeListDataLazyLoad(passData, $state);
          // setTimeout(() => {
          //   this.axiosGetAgreeListDataLazyLoad(passData, $state);
          // }, 1000);
        } else if (this.popAgreeListStatus.type === 'qa') {
          const passData = {
            article_id: '',
            resume_id: '',
            scoop_id: '',
            q_id: `${this.popAgreeListStatus.id}`,
            card: '1',
          };

          this.axiosGetAgreeListDataLazyLoad(passData, $state);
          // setTimeout(() => {
          //   this.axiosGetAgreeListDataLazyLoad(passData, $state);
          // }, 1000);
        }
      } else {
        $state.complete();
      }
    },

    handleGoToDoctorProfile(doctorId) {
      const redirectProcess = new Promise((resolve) => {
        this.handleClosePopBox();
        return resolve('done');
      });

      redirectProcess.then(() => {
        this.$router.push({
          name: 'profile-detail',
          params: {
            type: 'doctor',
            id: doctorId,
          },
        }).catch(() => true);
      });
    },

    handleAxiosDataTypeOnLoad(type, dataId) {
      let passData = {};

      switch (type) {
        case 'article':
          passData = {
            article_id: `${dataId}`,
            q_id: '',
            resume_id: '',
            scoop_id: '',
            card: '',
          };
          this.axiosGetAgreeListData(passData);
          break;

        case 'scoop':
          passData = {
            article_id: '',
            q_id: '',
            resume_id: '',
            scoop_id: `${dataId}`,
            card: '',
          };
          this.axiosGetAgreeListData(passData);
          break;

        case 'qa':
          passData = {
            article_id: '',
            q_id: `${dataId}`,
            resume_id: '',
            scoop_id: '',
            card: '',
          };
          this.axiosGetAgreeListData(passData);
          break;

        case 'resume':
          passData = {
            article_id: '',
            q_id: '',
            resume_id: `${dataId}`,
            scoop_id: '',
            card: '1',
          };
          this.axiosGetAgreeListData(passData);
          break;

        default:
          break;
      }
    },

    axiosGetAgreeListData(mergeObj) {
      const baseObj = {
        size: `${this.dataSize}`,
        page: `${this.dataCurrentIndex}`,
      };

      const PASS_DATA = { ...baseObj, ...mergeObj };

      getAgreeDoctorList('', PASS_DATA)
        .then((response) => {
          this.showLoading = false;
          console.log('getAgreeDoctorList', response.data, response);

          if (response.data.length) {
            const getLoadData = new Promise((resolve) => {
              response.data.forEach((element) => {
                this.dataContainer.push(element);
              });

              return resolve(this.dataContainer.length);
            });

            getLoadData.then((value) => {
              if (value < this.dataSize) {
                return;
              }

              this.infiniteId += 1;
              this.dataCurrentIndex = this.dataCurrentIndex + 1;
              this.dataFirstLoadDone = true;
            });
          } else {
            // this.resultFirstLoadEmpty = true;
          }
        })
        .catch((/* error */) => {
          // console.log('Resume Details: ', error.message);
        });
    },

    axiosGetAgreeListDataLazyLoad(mergeObj, state) {
      const baseObj = {
        size: `${this.dataSize}`,
        page: `${this.dataCurrentIndex}`,
      };

      const PASS_DATA = { ...baseObj, ...mergeObj };

      getAgreeDoctorList('', PASS_DATA)
        .then((response) => {
          this.isPreloading = false;
          // console.log('LAZY getAgreeDoctorList', response.data);

          if (response.data.length) {
            const getLoadData = new Promise((resolve) => {
              response.data.forEach((element) => {
                this.dataContainer.push(element);
              });

              return resolve(this.dataContainer.length);
            });

            getLoadData.then((value) => {
              this.dataCurrentIndex = this.dataCurrentIndex + 1;
              state.loaded();
            });
          } else {
            state.complete();
          }
        })
        .catch((/* error */) => {
          // console.log('Resume Details: ', error.message);
        });
    },

    // async handleCheckProgressBeforeLogin() {
    //   await this.handleFormsCheckToPass();
    //   await this.handleConnectDjangoWithApi();
    // },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      popAgreeListStatus: 'global/exportPopAgreeListStatus',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popAgreeList.scss';
</style>
